module.exports = "<div class=\"form-horizontal\">\n  <div class=\"form-group\">\n    <label class=\"col-lg-6\">Word Cloud Column Name</label>\n    <div class=\"col-lg-6\">\n      <select ng-options=\"name for name in queryResult.getColumnNames()\" ng-model=\"visualization.options.column\" class=\"form-control\"></select>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/visualizations/word-cloud/word-cloud-editor.html
// module id = 745
// module chunks = 1